import { PATH } from '../../constants/path.constant';
import { ROLE } from '../../constants/roles.constant';
import React from 'react';
import { Navigate } from 'react-router-dom';

function AdminDrivingGuard({ children }) {
  let user = JSON.parse(localStorage.getItem('user-info'));

  if (
    user?.role.includes(ROLE.DRIVING.ADMIN) ||
    user?.role.includes(ROLE.ADMIN) ||
    user?.role.includes(ROLE.DRIVING.TEACHER) ||
    user?.role.includes(ROLE.DRIVING.REPORTER)
  ) {
    return children;
  } else {
    return (
      <Navigate
        to={PATH.ADMIN.LOGIN}
        state={{
          from: window.location.pathname,
        }}
        replace={true}
      />
    );
  }
}

export default AdminDrivingGuard;
